'use strict';


const nl_form = {
    el: {
        form: document.querySelector('.news_nl_form'),
        email: document.querySelectorAll('.news_nl_form .field_email'),
        mandatory: document.querySelectorAll('.news_nl_form .field_mandatory'),
        submit: document.querySelector('.nl_submit')
    },

    init: function () {
        nl_form.events();
    },
    events: function () {
        if (nl_form.el.submit) {
            nl_form.el.submit.addEventListener('click', function (e) {
                e.preventDefault();
                nl_form.check();
                nl_form.readyToSubmit();
            });
        }
    },
    check: function () {
        // mandatory
        if (nl_form.el.mandatory) {
            nl_form.el.mandatory.forEach(e => {
                nl_form.checkMandatory(e);
            });
        }
    },

    checkMandatory: function (e) {
        let email = e.querySelector('input[type=email]');
        let checkbox = e.querySelector('input[type=checkbox]');

        if (email) {
            email.value != '' && isValidEmailAddress(e.querySelector('input').value) ? e.classList.remove('field_invalid') : e.classList.add('field_invalid');
        }
        if (checkbox) {
            checkbox.checked === true ? e.classList.remove('field_invalid') : e.classList.add('field_invalid');
        }
    },

    readyToSubmit: function () {
        // document.querySelectorAll('.form .field_invalid').length === 0 ? nl_form.errors() : nl_form.submit();
        nl_form.submit();
    },

    submit: function () {
        // nl_form.el.form.querySelector('.form_errorMsg-wrap').innerHTML = "";

        let request = new XMLHttpRequest();
        let protocol = window.location.protocol;
        let port = window.location.port;
        port.length > 0 ? port = ':' + port : port = '';
        let hostname = window.location.hostname;
        let path = nl_form.el.form.getAttribute('action');
        let fullUrl = protocol + '//' + hostname + port + path;

        let formData = new FormData();

        let email = document.querySelector('.form input[name=email]').value;
        let consent = "";
        document.querySelector('.form input[name=terms]').checked === true ? consent = "1" : consent = "";
        formData.append('email', email);
        formData.append('consent', consent);

        let languageField = document.documentElement.lang.substring(0, 2);
        formData.append('language', languageField);

        // do the request using form info
        request.open("POST", fullUrl, true);
        // want to distinguish from non-JS submits?
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

        request.onreadystatechange = function () {
            if (request.readyState == 4 && request.status == 200) {
                let obj = JSON.parse(request.responseText);
                if (obj.data.errors) {
                    // nok
                    nl_form.errors();
                    nl_form.el.form.classList.add('errors');
                    // transform object in array to loop into it
                    const errors = Object.values(obj.data.errors);
                    nl_form.el.form.querySelector('.form_errorMsg-wrap').innerHTML = '';
                    for (const error of errors) {
                        let newError = document.createElement("div");
                        let errorText = document.createTextNode(error);
                        newError.appendChild(errorText);
                        nl_form.el.form.querySelector('.form_errorMsg-wrap').appendChild(newError);
                    }

                    //grecaptcha.reset();
                } else {
                    // ok
                    nl_form.el.form.classList.remove('errors');
                    nl_form.el.form.classList.add('wellDone');
                    ga('send', 'event', 'Formulaires', 'sent', 'Inscription newsletter');
                }
            }
        };

        request.send(formData);
    },

    errors: function () {
        // console.log('il y a des erreurs');
        let id = document.querySelector('.form').getAttribute('id');
        location.href = "#";
        location.href = '#' + id;
    }
}

function isValidEmailAddress(emailAddress) {
    let pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
};

export default nl_form;



// WEBPACK FOOTER //
// ./src/scripts/components/nl_form.js